import HeaderContent from "@/components/header/header_content";
import GraphContent from "@/components/graphContent/graph_content";
import moment from "moment";
import { AuthStoreType } from "@/types/types";

export class RequestParamsMakerForHeader {
  /**
   * スプレッド様向け全機種サマリデータCSVダウンロードAPIにアクセス
   * @param self ヘッダーコンテンツ
   * @param userId
   * @param authstore
   */
  public static makeDownloadCsvForSpreadParams(
    self: HeaderContent,
    authstore: AuthStoreType
    ) {
    return {
      auth_store: authstore,
      user_timezone: self.timeZone,
      search_condition: {
        fromDate: this.modifyFromPcLocalDateToUserTimezoneDatetimeString(
          self.downloadCsvForSpreadFromDate, self.timeZone),
        toDate: this.modifyFromPcLocalDateToUserTimezoneDatetimeString(
          self.downloadCsvForSpreadToDate, self.timeZone),
        searchType: "between"
      }
    };
  }
  /**
   * date-pickerからくる時刻がPCタイムゾーンに依存しているので、
   * ユーザー設定のタイムゾーンベースに修正
   */
  public static modifyFromPcLocalDateToUserTimezoneDatetimeString(
    date: Date,
    userTimezone: HeaderContent["timeZone"]
  ) {
    return moment(date)
      .utcOffset(userTimezone, false)
      .format("YYYY-MM-DD HH:mm:ss")
  }
}
